class ReportImagesController {
  constructor() {
    "ngInject";

    let vm = this;
    vm.images = [];
    vm.zoom = [];

    vm.$onInit = function () {
      if (vm.resolve && vm.resolve.images) {
        vm.images = vm.resolve.images;
      }
    }
  }
}

export default ReportImagesController;



// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.controller.js